import script from "./NoAccessPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoAccessPopup.vue?vue&type=script&setup=true&lang=ts"

import "./NoAccessPopup.vue?vue&type=style&index=0&id=42fb6054&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42fb6054"]])

export default __exports__